import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["condition", "inputUse", "isRollingDateOffsetInputEnabled", "onChange"];
import FilterOperatorRollingDateRangeInput from './FilterOperatorRollingDateRangeInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorRollingDateInput = props => {
  const {
      condition,
      inputUse,
      isRollingDateOffsetInputEnabled,
      onChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FilterOperatorRollingDateRangeInput, Object.assign({
      condition: condition,
      inputUse: inputUse,
      onChange: onChange
    }, rest)), isRollingDateOffsetInputEnabled && /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorRollingDateInput.offsetLabel"
      }),
      padding: "0",
      children: /*#__PURE__*/_jsx(NumberInput, {
        onChange: evt => {
          const {
            target: {
              value: newRollingOffset
            }
          } = evt;
          onChange(syntheticEvent(condition.set('rollingOffset', newRollingOffset)));
        },
        placeholder: 0,
        use: inputUse,
        value: condition.rollingOffset
      })
    })]
  });
};
export default /*#__PURE__*/memo(FilterOperatorRollingDateInput);